import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';

import { CEDE_CONTRACT } from 'src/store/actions/contractActions';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';

const CurrentStep = ({
  activeStep,
  open,
  contract,
  data,
  onNext,
  onBack,
  onSubmit,
  resetRef,
  setData,
  handleClose
}) => {
  const loading = useSelector(isLoadingSelector([CEDE_CONTRACT.action]));

  if (activeStep === 0) {
    return (
      <StepOne
        open={open}
        data={data}
        contract={contract}
        handleBack={onBack}
        handleNext={onNext}
        resetRef={resetRef}
        setData={setData}
      />
    );
  }

  if (activeStep === 1) {
    return (
      <StepTwo
        data={data}
        handleNext={onNext}
        open={open}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }

  if (activeStep === 2) {
    return (
      <StepThree
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        handleSubmit={onSubmit}
        loading={loading}
        handleClose={handleClose}
      />
    );
  }

  if (activeStep === 3 && data.balance !== 0) {
    return (
      <StepFour
        data={data}
        handleBack={onBack}
        handleSubmit={onSubmit}
        loading={loading}
        handleClose={handleClose}
      />
    );
  }

  return null;
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  data: PropTypes.any.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetRef: PropTypes.any.isRequired,
  setData: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  contract: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default CurrentStep;
